<template>
  <div id="receipt">
    <div
        style="width: 898px;height:1265px; display: flex;justify-content: center;align-items: center;
margin: -10px 0 0 -10px;">
      <div class="receipt"
           style=" background-color: #fff; font-size: 20px;padding: 15px 25px 50px 25px;">
        <!--        -->
        <div>
          <div class="receiptHead"
               style=" height: 100px;position: relative;margin-bottom: -16px;display: flex;justify-content: center;align-items: center;">
            <div class="receiptTitle"
                 style=" font-size: 28px;display: flex;justify-content: space-between;align-items: center;width: 110px;">
              <span>收</span>
              <span>据</span>
            </div>
          </div>
          <div class="receiptContent">
            <div class="receiptDate" style=" display: flex;justify-content: space-between;margin: 2px 10px;">
              <div class="receiptNumber">
                <span>NO. <span> {{ receiptNo }} </span></span>
              </div>
              <div>
                <span style=" min-width: 50px;text-align: center"> {{ this.data.receiptYear }} 年 </span>
                <span style=" min-width: 50px;text-align: center"> {{ this.data.receiptMonth }} 月 </span>
                <span style=" min-width: 50px;text-align: center"> {{ this.data.receiptDay }} 日 </span>
              </div>
            </div>
            <div class="receiptMain"
                 style="border: 2px solid #000;border-radius: 10px;line-height: 35px;font-size: 24px;">
              <p class="receiptMainPartp" style=" display: flex;padding: 8px 15px;">
                <span style=" width: 100px;"> 今收到 </span>
                <span style="flex: 1;width: 100%;display: inline-block;border-bottom: 1px solid #000;height: 35px;"
                      class="receiptMainPartu">{{
                    this.data.receiptMainPart
                  }}</span>
              </p>
              <p class="receiptProjectName" style=" display: flex;
        padding: 8px 15px;">
          <span class="firstTitleName" style=" width: 100px;
          letter-spacing: 7px;">交 来  </span>
                <span class="projectName"
                      style=" flex: 1;width: 100%;display: inline-block;border-bottom: 1px solid #000;height: 35px;"> {{
                    this.receiptProjectName
                  }}</span>
              </p>

              <p class="price" style="  display: flex;padding: 8px 15px;">
          <span> <span class="spanprice" style="width: 180px;
          letter-spacing: 7px;"> 金 </span>额(大写)</span>
                <span class="bigPrice"
                      style=" width: 555px;display: flex;justify-content: space-around;font-size: 20px;">
<!--           <span><span class="priceu">{{  }}</span>佰 </span>-->
                  <!--           <span><span class="priceu">{{  }}</span>拾 </span>-->
                  <!--           <span><span class="priceu">{{  }} 叁</span>万 </span>-->
                  <!--           <span><span class="priceu">{{  }} 叁</span>仟 </span>-->
                  <!--           <span><span class="priceu">{{  }} 捌</span>佰 </span>-->
                  <!--           <span><span class="priceu">{{  }} 零</span>拾 </span>-->
                  <!--           <span><span class="priceu">{{  }} 零</span>元 </span>-->
                  <!--           <span><span class="priceu">{{  }} 零</span>角 </span>-->
                  <!--           <span><span class="priceu">{{  }} 零</span>分 </span>-->
            {{ wordFigure }}

        </span>
                ¥ <span class="smallPrice"
                        style=" flex: 1;display: inline-block;border-bottom: 1px solid #000;height: 40px;">  {{
                  this.data.receiptPrice
                }}</span>
              </p>
              <p class="accessSpeace"
                 style="letter-spacing: 7px;border-top: 1px solid #000;margin-bottom: 0; padding: 8px 15px;"> 附 注：</p>

            </div>
            <div class="receiptFooter" style="display: flex;justify-content: left;">
        <span class="receiptImg"
              style=" min-width: 180px;  display: flex; width: 300px;position: relative;margin: 10px 0 0 5px;">
           <span class="receiptText">
             发据单位(盖章)
             <img style=" width: 100px;  position: absolute;top: -252%;left: 45%;"
                  :src="`https://gecacademy.oss-cn-beijing.aliyuncs.com/crm/caiwu/`+ this.data.receiptImg" alt="">
           </span>
        </span>
<!--              <span style=" min-width: 180px;"> </span>-->
              <span style=" min-width: 180px;"> </span>
              <span style=" min-width: 180px;"> 经手人：熊文慧</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {generatePdf} from "@/api/financial-center";

export default {
  name: "createBackMoneyReceipt",
  props: {
    data: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      // data: {
      //   receiptNo: '8821253',
      //   receiptYear: '2024',
      //   receiptMonth: '06',
      //   receiptDay: '18',
      //   receiptMainPart: '吕姣姣',
      //   receiptProjectName: '项目费用',
      //   receiptImg: 'https://gecacademy.oss-cn-beijing.aliyuncs.com/crm/2024-06-18%2011-47-00-14a84ddd18ffd2e84b15954ce06a52ae.jpeg',
      //   receiptPrice: '33800.00',
      // }
      receiptProjectName: '项目费用',
      // wordFigure: '',
    }
  },
  created() {
    // 小写转大写
    // this.data.receiptPrice
    // console.log('this.data------', this.data)
    // if(this.data){
    //   this.doDownload()
    // }
    // console.log('------',this.DX(138800.98))


  },
  computed: {
    wordFigure() {
      return this.DX(this.data.receiptPrice)
    },
    receiptNo() {
      const str = this.data.receiptNo.substr(3)
      return str
    }

  },

  methods: {
    // 下载
    // generateImage() {
    //   console.log('我被调用了')
    //   const element = document.getElementById('receipt'); // 替换为目标元素的id或class
    //
    //   html2canvas(element).then((canvas) => {
    //     const image = canvas.toDataURL('image/png');
    //     this.$emit('close')
    //     const link = document.createElement('a');
    //     link.href = image;
    //     link.download = this.data.receiptNo + '.png';
    //     link.click();
    //   });
    //
    // },

    generateImage() {
      const element = document.getElementById('receipt').innerHTML
      generatePdf({
        htmlStr: element,
        marginBottom: 0,
        marginTop: 0
      }).then((res) => {
        this.$emit('close')
        // console.log('res------', res)
        // const link = document.createElement('a');
        // link.href = res.url;
        // link.download = this.data.receiptNo + '.png';
        // link.click();
        window.open(res.url, '_blank')
      })
    },
    DX(n) {
      if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n))
        return "数据非法";
      let unit = "仟佰拾亿仟佰拾万仟佰拾元角分", str = "";
      n += "00";
      const p = n.indexOf('.');
      if (p >= 0)
        n = n.substring(0, p) + n.substr(p + 1, 2);
      unit = unit.substr(unit.length - n.length);
      for (let i = 0; i < n.length; i++)
        str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
      return str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
    },

    urlToBase64(url) {
      // 将URL转换为ASCII字符串
      const binaryString = unescape(encodeURIComponent(url));
      // 对二进制字符串进行Base64编码
      const base64String = btoa(binaryString);
      return base64String;
    }

  },
  Watch: {}
}
</script>

<!--<style scoped lang="stylus">-->
<!--.receipt {-->
<!--  width: 898px;-->
<!--  background-color: #fff;-->
<!--  font-size: 16px;-->
<!--  padding: 15px 25px 35px 25px;-->

<!--  .receiptHead {-->
<!--    height: 70px;-->
<!--    position: relative;-->
<!--    margin-bottom: -16px;-->
<!--    display: flex;-->
<!--    justify-content: center;-->
<!--    align-items: center;-->

<!--    .receiptTitle {-->
<!--      font-size: 24px;-->
<!--      display: flex;-->
<!--      justify-content space-between;-->
<!--      align-items center;-->
<!--      width: 110px;-->

<!--      > span {-->
<!--        //letter-spacing: 60px;-->
<!--        //text-align: center;-->
<!--        //width: 80px;-->
<!--        //display: flex-->
<!--        //justify-content: space-between;-->
<!--        //align-items center-->
<!--      }-->
<!--    }-->


<!--    .receiptNumber {-->
<!--      float: right;-->
<!--      position: absolute;-->
<!--      right: 7%;-->
<!--      top: 35%;-->
<!--    }-->
<!--  }-->

<!--  .receiptContent {-->
<!--    .receiptDate {-->
<!--      display: flex;-->
<!--      justify-content: end;-->
<!--      margin: 0 10px;-->

<!--      span {-->
<!--        min-width: 50px;-->
<!--        text-align: center-->
<!--        //font-weight: bold;-->
<!--      }-->
<!--    }-->

<!--    .receiptMain {-->
<!--      border: 2px solid #000;-->
<!--      border-radius: 10px;-->
<!--      line-height: 50px;-->
<!--      font-size: 20px;-->

<!--      .receiptMainPartp {-->
<!--        display flex-->
<!--        padding: 8px 15px;-->

<!--        > span {-->
<!--          width: 80px;-->
<!--        }-->

<!--        .receiptMainPartu {-->
<!--          flex: 1;-->
<!--          width: 100%;-->
<!--          display: inline-block;-->
<!--          border-bottom: 1px solid #000;-->
<!--          height: 40px;-->
<!--        }-->
<!--      }-->

<!--      .receiptProjectName {-->
<!--        //width: 100%;-->
<!--        display flex;-->
<!--        padding: 8px 15px;-->

<!--        .firstTitleName {-->
<!--          width: 80px;-->
<!--          letter-spacing: 7px;-->
<!--        }-->

<!--        .projectName {-->
<!--          flex: 1;-->
<!--          width: 100%;-->
<!--          display: inline-block;-->
<!--          border-bottom: 1px solid #000;-->
<!--          height: 40px;-->
<!--        }-->
<!--      }-->

<!--      .price {-->
<!--        //width: 100%;-->
<!--        display flex;-->
<!--        padding: 8px 15px;-->

<!--        .spanprice {-->
<!--          width: 150px;-->
<!--          letter-spacing: 7px;-->
<!--        }-->

<!--        .bigPrice {-->
<!--          width: 555px;-->
<!--          display: flex;-->
<!--          justify-content: space-around;-->
<!--          font-size: 16px;-->

<!--          .priceu {-->
<!--            width: 100px;-->
<!--          }-->
<!--        }-->

<!--        .smallPrice {-->
<!--          flex: 1;-->
<!--          display: inline-block;-->
<!--          border-bottom: 1px solid #000;-->
<!--          height: 40px;-->
<!--        }-->
<!--      }-->

<!--      .accessSpeace {-->
<!--        letter-spacing: 7px;-->
<!--        border-top: 1px solid #000;-->
<!--        margin-bottom: 0;-->
<!--        padding: 8px 15px;-->
<!--      }-->
<!--    }-->
<!--  }-->

<!--  .receiptFooter {-->
<!--    display: flex;-->
<!--    justify-content: left;-->


<!--    span {-->
<!--      min-width: 180px;-->
<!--    }-->

<!--    img {-->
<!--      width: 100px;-->
<!--    }-->

<!--    .receiptImg {-->
<!--      display: flex;-->
<!--      width: 300px;-->
<!--      position: relative;-->

<!--      .receiptText {-->
<!--        img {-->
<!--          position: absolute;-->
<!--          top: -222%;-->
<!--          left: 45%;-->
<!--        }-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</style>-->